var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/document-text"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3333 1.66675H6.66667C3.75 1.66675 2.5 3.33341 2.5 5.83341V14.1667C2.5 16.6667 3.75 18.3334 6.66667 18.3334H13.3333C16.25 18.3334 17.5 16.6667 17.5 14.1667V5.83341C17.5 3.33341 16.25 1.66675 13.3333 1.66675ZM6.66667 10.2084H10C10.3417 10.2084 10.625 10.4917 10.625 10.8334C10.625 11.1751 10.3417 11.4584 10 11.4584H6.66667C6.325 11.4584 6.04167 11.1751 6.04167 10.8334C6.04167 10.4917 6.325 10.2084 6.66667 10.2084ZM13.3333 14.7917H6.66667C6.325 14.7917 6.04167 14.5084 6.04167 14.1667C6.04167 13.8251 6.325 13.5417 6.66667 13.5417H13.3333C13.675 13.5417 13.9583 13.8251 13.9583 14.1667C13.9583 14.5084 13.675 14.7917 13.3333 14.7917ZM15.4167 7.70841H13.75C12.4833 7.70841 11.4583 6.68341 11.4583 5.41675V3.75008C11.4583 3.40841 11.7417 3.12508 12.0833 3.12508C12.425 3.12508 12.7083 3.40841 12.7083 3.75008V5.41675C12.7083 5.99175 13.175 6.45841 13.75 6.45841H15.4167C15.7583 6.45841 16.0417 6.74175 16.0417 7.08341C16.0417 7.42508 15.7583 7.70841 15.4167 7.70841Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentText);
export default __webpack_public_path__ + "static/media/document-text.c0ff6e63c922f2d25601c0bfc070bece.svg";
export { ForwardRef as ReactComponent };